import { useRoutes, Navigate } from "react-router-dom";
import { DashboardLayout } from "@/layouts/dashboard/DashboardLayout";

// Auth pages
import BaseAuth from "pages/Auth";
import NewPassword from "pages/Auth/deleteIfnotUse/SignUp/NewPassword";
import ProfileSetup from "pages/Auth/deleteIfnotUse/SignUp/Step/ProfileSetup";
import TelegramCallback from "pages/TelegramCallback";
import CallbackLogin from "pages/Auth/Google/CallbackLogin";

// App pages
import HomePage from "pages/Apps/Home";
import PlansMainPage from "pages/Apps/Plans";
import PlanDetail from "pages/Apps/Plans/PlanDetail";
import ContractSigning from "pages/Apps/Plans/ContractSigning";
import SigningContract from "@/pages/Apps/Plans/ReSigningContract";
import WeeksChallenge13 from "pages/Apps/Plans/13WeeksChallenge";
import Checkout from "pages/Apps/Plans/Checkout";
import ProfilePage from "pages/Apps/Profile";
import EditProfileTab from "pages/Apps/Profile/EditProfileTab";
import ChangePasswordTab from "pages/Apps/Profile/ChangePasswordTab";
import MyInvestmentTab from "pages/Apps/Profile/MyInvestmentTab";
import NotFound from "pages/NotFound";
import MemberManagement from "pages/Apps/Loyalty/MemberManagement";
import MemberDetails from "pages/Apps/Loyalty/MemberDetails";
import SettingsLayout from "pages/Apps/Settings";
import Billing from "pages/Apps/Settings/Billing";
import Referrals from "pages/Apps/Settings/Referrals";
import Verification from "@/pages/Apps/Profile/Verification";
import BankingTab from "@/pages/Apps/Profile/BankingTab";
import DocumentsTab from "@/pages/Apps/Profile/DocumentsTab";
import TransactionHistory from "pages/Apps/Transactions";
import AdminTransactionPage from "@/pages/Admin/Transaction";
import InvestmentTransactionAdmin from "@/pages/Admin/Investment/inventment";
import RevenueManagementPage from "@/pages/Admin/Setting/Revenue";
import { message } from "antd";
import SettleDaily from '@/pages/Admin/Setting/SettleDaily';
import CreateAccountsPage from "@/pages/Admin/Accounts/create";
import CommissionPage from "@/pages/Admin/Commission";

// Placeholder cho page chưa làm xong
const PlaceholderPage = ({ title }: { title: string }) => (
  <div className="p-8">
    <h1 className="text-2xl font-bold">{title}</h1>
    <p>This page is under development.</p>
  </div>
);

// Protected Route - có thể để comp bên ngoài nếu cần tái sử dụng
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = localStorage.getItem("user");
  const token = localStorage.getItem("token");

  if (!user || !token) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// Dashboard wrapper
const DashboardRoute = ({ userRole }: { userRole: "user" | "super_admin" }) => {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  // Redirect users with 'User' role away from admin routes
  if (userRole === "super_admin" && user?.roles_display === "User") {
    message.error("You do not have permission to access the admin dashboard.");
    return <Navigate to="/home" replace />;
  }

  return (
    <ProtectedRoute>
      <DashboardLayout
        userRole={userRole}
        user={user || { email: `${userRole}@beqholdings.com` }}
      />
    </ProtectedRoute>
  );
};

// route chung cho các roles
const commonRoutes = [
  {
    path: "profile",
    element: <ProfilePage />,
    children: [
      { index: true, element: <EditProfileTab /> },
      { path: "change-password", element: <ChangePasswordTab /> },
      { path: "investment", element: <MyInvestmentTab /> },
      { path: "verification", element: <Verification /> },
      { path: "banking", element: <BankingTab /> },
      { path: "documents", element: <DocumentsTab /> },
    ],
  },
  {
    path: "settings",
    element: <SettingsLayout />,
    children: [
      { index: true, element: <PlaceholderPage title="Profile Settings" /> },
      { path: "billing", element: <Billing /> },
      { path: "referrals", element: <Referrals /> },
    ],
  },
  // Thêm các routes dùng chung khác ở đây (notifications, etc.)
];

export function AppRoutes() {
  return useRoutes([
    { path: "/", element: <Navigate to="/home" replace /> },

    // Auth Routes - Public
    { path: "/login", element: <BaseAuth routeType="login" /> },
    { path: "/sign-up", element: <BaseAuth routeType="signup" /> },
    { path: "/sign-up/step", element: <ProfileSetup /> },
    {
      path: "/forget-password",
      element: <BaseAuth routeType="forgot-password" />,
    },
    { path: "/verify-otp", element: <BaseAuth routeType="active-account" /> },
    { path: "/reset-password", element: <NewPassword /> },
    { path: "/api/v1/telegram/callback", element: <TelegramCallback /> },
    { path: "/callback-login", element: <CallbackLogin /> },

    // Admin Routes - Protected - sẽ phân quyền chi tiết hơn để chặn người khác vào sau này
    // {
    //   path: "/admin/*",
    //   element: <DashboardRoute userRole="super_admin" />,
    //   children: [
    //     {
    //       path: "dashboard",
    //       element: <PlaceholderPage title="Admin Dashboard" />,
    //     },
    //     { path: "analytics", element: <PlaceholderPage title="Analytics" /> },
    //     { path: "transactions", element: <AdminTransactionPage /> },
    //     { path: "users", element: <PlaceholderPage title="User Management" /> },
    //     { path: "users/create-batch", element: <CreateAccountsPage /> },
    //     { path: "commissions", element: <CommissionPage /> },
    //     { path: "plans", element: <PlaceholderPage title="Plans Management" /> },
    //     { path: "investment", element: <InvestmentTransactionAdmin /> },
    //     { path: "settings/revenue", element: <RevenueManagementPage /> },
    //     { path: "settings/settle-daily", element: <SettleDaily /> },

    //     ...commonRoutes,
    //     { path: 'dashboard', element: <PlaceholderPage title="Admin Dashboard" /> },
    //     { path: 'analytics', element: <PlaceholderPage title="Analytics" /> },
    //     { path: 'transactions', element: <AdminTransactionPage /> },
    //     { path: 'users', element: <PlaceholderPage title="User Management" /> },
    //     { path: 'plans', element: <PlaceholderPage title="Plans Management" /> },
    //     { path: 'payments', element: <InvestmentTransactionAdmin /> },
    //     { path: 'settings/revenue', element: <RevenueManagementPage /> },
    //     { path: 'settings/settle-daily', element: <SettleDaily /> },

    //     ...commonRoutes,
    //   ],
    // },

    // User Routes - Protected, đăng nhập mới vào được
    {
      element: <DashboardRoute userRole="user" />,
      children: [
        { path: "home", element: <HomePage /> },
        { path: "plans", element: <PlansMainPage /> },
        { path: "plans/:id", element: <PlanDetail /> },
        { path: "plans/:id/contract", element: <ContractSigning /> },
        { path: "signingContract", element: <SigningContract /> },
        { path: "plans/:id/13w-challenge", element: <WeeksChallenge13 /> },
        { path: "plans/:id/checkout", element: <Checkout /> },
        { path: "members", element: <MemberManagement /> },
        { path: "members/:memberId", element: <MemberDetails /> },
        { path: "transactions", element: <TransactionHistory /> },
        {
          path: "points",
          element: <PlaceholderPage title="Quản lý điểm thưởng" />,
        },
        {
          path: "gifts",
          element: <PlaceholderPage title="Quản lý quà tặng" />,
        },
        ...commonRoutes,
      ],
    },

    // 404
    { path: "*", element: <NotFound /> },
  ]);
}
